import React from "react";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import { useTranslation } from "react-i18next";
import styles from "./sharedStyles.module.scss";

interface UpdateExistingUsersSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const UpdateExistingUsersSwitch: React.FC<UpdateExistingUsersSwitchProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.switchTextContainer}>
      <Switch checked={value} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
      <span>{t("user_management.update_existing_users")}</span>
    </div>
  );
};
